import InlineFormInput from "../../FormGroups/InlineFormInput";

export default function Edit({ command, commandIdx, control, errors }) {
    return (
        <InlineFormInput
            name={`commands.${commandIdx}.settings.z`}
            control={control}
            defaultValue={command.settings?.z || ""}
            errors={errors?.commands?.[commandIdx]?.settings?.z}
            placeholder="z"
            inputType="text"
            unit="m"
        />
    );
}
